import { formatNumber } from "../../utils/useFormatNumber"


const combinedStatFields = ['moneySaved', 'minutesSaved']
const combinedFieldNameMap = {
    moneySaved: 'Saved DKK',
    minutesSaved: 'Saved Hours'
}
export const combinedBarProcessor = (statsData) => {
  const monthsOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const monthlyDataMap = {}, allFieldsSet = new Set()

  statsData.forEach(stat => {
    stat.monthlyStats?.forEach(monthStat => {
      if (monthStat.month && monthStat.year) {
        const month = new Date(monthStat.year, monthStat.month - 1).toLocaleString('default', { month: 'short' })
        monthlyDataMap[month] ??= { name: month }

        combinedStatFields.forEach(field => {
          if (monthStat[field]) {
            const label = combinedFieldNameMap?.[field] || field
            allFieldsSet.add(label)
            const value = field === 'minutesSaved' ? monthStat[field] / 60 : monthStat[field]
            monthlyDataMap[month][label] = (monthlyDataMap[month][label] || 0) + value
          }
        })
      }
    })
  })

  const filtered = monthsOrder
    .filter(month => {
      const data = monthlyDataMap[month]
      return data && Array.from(allFieldsSet).some(f => data[f])
    })
    .map(month => monthlyDataMap[month])

  const categories = filtered.map(row => row.name)
  const series = Array.from(allFieldsSet).map(label => ({
    name: label,
    data: filtered.map(row => formatNumber(row[label] || 0))
  }))

  return { categories, series }
}